import React, { Component } from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";
import handleViewport from 'react-in-viewport';
import Cookies from "universal-cookie";
import FooterShade from "../partials/footer";
import TopShade from "../partials/topshade";

const cookies = new Cookies();

const GalerijasQuery = gql`
  query galerijas($cursor: String) {
    fotos(first: 3, after: $cursor) {
      edges {
        node {
          galerijas {
            foto {
              sourceUrl(size: MEDIUM_LARGE)
            }
          }
          title(format: RENDERED)
          slug
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    videos(first: 2, after: $cursor) {
      edges {
        node {
          video_acf {
            videoUrl
          }
          title(format: RENDERED)
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    audios(first: 3, after: $cursor) {
      edges {
        node {
          audios {
            audioUrl
          }
          title(format: RENDERED)
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    themeGeneralSettings {
      optionsPage {
        gimmeMore
        gimmeMoreEn
        galerijasTitle
        galerijasTitleEn
        fotoTitle
        fotoTitleEn
        videoTitle
        videoTitleEn
        audioTitle
        audioTitleEn
      }
    }
  }
`;

class Galerijas extends Component {
  render() {
    const {
      data: { loading, errors, fotos, audios }
    } = this.props;
     //console.log(this.props.data);



    return (
      <div id = "galerijas"
      className = "container blogs-container"
      data-headertitle = {
          cookies.get("lang") === "LV" ? "Galerijas" : cookies.get("lang") === "EN" ? "Galleries" : null
                }>
      {!loading && fotos && (
        <div id="carouselId" className="carousel slide narrow-carousel" data-ride="carousel">
          <TopShade />
          <div className="carousel-inner" role="listbox">
            <div
          className={`carousel-item active`}
          
          style={{
            backgroundImage: `url(${fotos.edges[0].node.galerijas.foto[0].sourceUrl})`
          }}
        ></div>
            <div className="carousel-item-herotextnarrow-wrap">
              <div className="herotext">{cookies.get("lang") === "LV" &&
              this.props.data.themeGeneralSettings.optionsPage.galerijasTitle}
            {cookies.get("lang") === "EN" &&
              this.props.data.themeGeneralSettings.optionsPage.galerijasTitleEn}</div>
            </div>
          </div>
          <FooterShade />
        </div>
        )}
        {!loading && fotos && (

          <div className="fotoTitleWrap mb-4">
            {cookies.get("lang") === "LV" &&
              this.props.data.themeGeneralSettings.optionsPage.fotoTitle}
            {cookies.get("lang") === "EN" &&
              this.props.data.themeGeneralSettings.optionsPage.fotoTitleEn}
            </div>
        )}

        <div className="row">
          {loading && <div className="loader" />}
          {errors && <div className="errors">...</div>}

          {!loading && !fotos && (
            <span className="none">Nav foto galeriju...</span>
          )}

          {!loading &&
            fotos &&
            fotos.edges.map((prop, i) => (
              <div className="col-12 col-sm-6 col-md-4 " key={i}>
                          <Link
              to={`/${cookies.get("lang").toLowerCase()}/foto/${prop.node.slug}`}
              className="notikumi-single-card-a"
            >
                <div className="galWrap">
                  <div
                    className="singleFotoGalerija square"
                    style={{
                      backgroundImage: `url(${prop.node.galerijas.foto[0].sourceUrl})`
                    }}
                  >
                    <div className="kom-wrap-text embed-responsive-item">
                      <span className="kom-wrap-text-teksts">
                        {prop.node.title}
                      </span>
                    </div>
                  </div>
                  </div>
                  </Link>
              </div>
            ))}

          {!loading && fotos && fotos.pageInfo.hasNextPage === true && (
            <div className="loadMoreWrap mb-5">
              <button onClick={this.onFetchMore}>
                {cookies.get("lang") === "LV" &&
                  this.props.data.themeGeneralSettings.optionsPage.gimmeMore}
                {cookies.get("lang") === "EN" &&
                  this.props.data.themeGeneralSettings.optionsPage.gimmeMoreEn}
              </button>
            </div>
          )}
        </div>
        {/* {!loading && videos && (
          <div className="fotoTitleWrap mb-4">
            {cookies.get("lang") === "LV" &&
              this.props.data.themeGeneralSettings.optionsPage.videoTitle}
            {cookies.get("lang") === "EN" &&
              this.props.data.themeGeneralSettings.optionsPage.videoTitleEn}
          </div>
        )}

        <div className="row">
          {loading && <div className="loader" />}
          {errors && <div className="errors">...</div>}

          {!loading && !videos && (
            <span className="none">Nav video galeriju...</span>
          )}

          {!loading &&
            videos &&
            videos.edges.map((prop, i) => {
              return (
                <div className="col-12 col-sm-6 " key={i}>
                  <div className="galWrap">
                    <div className="singleFotoGalerija">
                      <ReactPlayer
                        url={prop.node.video_acf.videoUrl}
                        width="100%"
                        config={{
                          youtube: {
                            playerVars: { fs: 1 }
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}

          {!loading && videos && videos.pageInfo.hasNextPage === true && (
            <div className="loadMoreWrap mb-5">
              <button onClick={this.onFetchMoreVideos}>
                {cookies.get("lang") === "LV" &&
                  this.props.data.themeGeneralSettings.optionsPage.gimmeMore}
                {cookies.get("lang") === "EN" &&
                  this.props.data.themeGeneralSettings.optionsPage.gimmeMoreEn}
              </button>
            </div>
          )}
        </div> */}
        {!loading && audios && (
          <div className="fotoTitleWrap mb-4">
            {cookies.get("lang") === "LV" &&
              this.props.data.themeGeneralSettings.optionsPage.audioTitle}
            {cookies.get("lang") === "EN" &&
              this.props.data.themeGeneralSettings.optionsPage.audioTitleEn}
          </div>
        )}

        <div className="row">
          {loading && <div className="loader" />}
          {errors && <div className="errors">...</div>}

          {!loading && !audios && (
            <span className="none">Nav audio galeriju...</span>
          )}

          {!loading &&
            audios &&
            audios.edges.map((prop, i) => {
              return (
                <div className="col-12" key={i}>
                  <div className="galWrap">
                    <div className="singleFotoGalerija">
                      {prop.node.audios.audioUrl.includes("mixcloud.com") ? 
                      
                        <iframe title={i} width="100%" height="200" src={"https://www.mixcloud.com/widget/iframe/?hide_cover=1&feed=" + prop.node.audios.audioUrl} frameBorder="0" ></iframe>
                      
                      :                       <ReactPlayer
                        url={prop.node.audios.audioUrl}
                        width="100%"
                        height="200px"
                        
                      />}


                      
                    </div>
                  </div>
                </div>
              );
            })}

          {!loading && audios && audios.pageInfo.hasNextPage === true && (
            <div className="loadMoreWrap mb-5">
              <button onClick={this.onFetchMoreAudios}>
                {cookies.get("lang") === "LV" &&
                  this.props.data.themeGeneralSettings.optionsPage.gimmeMore}
                {cookies.get("lang") === "EN" &&
                  this.props.data.themeGeneralSettings.optionsPage.gimmeMoreEn}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
  onFetchMore = () => {
    const {
      data: { fotos, fetchMore }
    } = this.props;
    //console.log(this.props);

    fetchMore({
      variables: {
        cursor: fotos.pageInfo.endCursor
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newEdges = fetchMoreResult.fotos.edges;
        const pageInfo = fetchMoreResult.fotos.pageInfo;

        return newEdges.length
          ? {
              // Put the new pages at the end of the list and update `pageInfo`
              // so we have the new `endCursor` and `hasNextPage` values
              fotos: {
                __typename: previousResult.fotos.__typename,
                edges: [...previousResult.fotos.edges, ...newEdges],
                pageInfo
              }
            }
          : previousResult;
      }
    });
  };
  // onFetchMoreVideos = () => {
  //   const {
  //     data: { videos, fetchMore }
  //   } = this.props;
  //   //  console.log(this.props);

  //   fetchMore({
  //     variables: {
  //       cursor: videos.pageInfo.endCursor
  //     },
  //     updateQuery: (previousResult, { fetchMoreResult }) => {
  //       const newEdges = fetchMoreResult.videos.edges;
  //       const pageInfo = fetchMoreResult.videos.pageInfo;

  //       return newEdges.length
  //         ? {
  //             // Put the new pages at the end of the list and update `pageInfo`
  //             // so we have the new `endCursor` and `hasNextPage` values
  //             videos: {
  //               __typename: previousResult.videos.__typename,
  //               edges: [...previousResult.videos.edges, ...newEdges],
  //               pageInfo
  //             }
  //           }
  //         : previousResult;
  //     }
  //   });
  // };
  onFetchMoreAudios = () => {
    const {
      data: { audios, fetchMore }
    } = this.props;
    console.log(this.props);

    fetchMore({
      variables: {
        cursor: audios.pageInfo.endCursor
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newEdges = fetchMoreResult.audios.edges;
        const pageInfo = fetchMoreResult.audios.pageInfo;

        return newEdges.length
          ? {
              // Put the new pages at the end of the list and update `pageInfo`
              // so we have the new `endCursor` and `hasNextPage` values
              audios: {
                __typename: previousResult.audios.__typename,
                edges: [...previousResult.audios.edges, ...newEdges],
                pageInfo
              }
            }
          : previousResult;
      }
    });
  };
}

const MySection = handleViewport(graphql(GalerijasQuery)(Galerijas), {
  rootMargin: '-1.0px'
});


export default MySection;
